import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import axiosNewInstance from "../../config/Api";
import toast, { Toaster } from "react-hot-toast";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import LangData from './../common/LangData';

const Profile = ({ lang }) => {
  const [userProfile, setUserProfile] = useState(null);
  const history = useHistory();

  useEffect(() => {
    fetchProfile();
  }, []);

  const user = useSelector((state) => state?.user);
  console.log("User Info", user?.loginuser);

  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found");
      }

      const response = await axiosNewInstance.post(
        "/api-app/get-user-profiles",
        {
          Name: "Fahim",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === 1 && response.data.data.user) {
        const userProfileData = response.data.data.user;
        setUserProfile({
          id: userProfileData.id,
          name: `${userProfileData.en_first_name} ${
            userProfileData.en_last_name || ""
          }`,
          email: userProfileData.email,
          phone: userProfileData.mobile,
          role: userProfileData.user_type === 1 ? "Admin" : "User",
        });
      } else {
        console.error("Invalid data structure:", response.data);
      }
    } catch (error) {
      if (error.response?.data?.status === 0) {
        localStorage.removeItem("authToken");
        history.replace("/login");
      }
    }
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    phone: Yup.string().required("Phone number is required"),
    newPassword: Yup.string().min(6, "Password must be at least 6 characters"),
    confirmPassword: Yup.string().oneOf(
      [Yup.ref("newPassword"), null],
      "Passwords must match"
    ),
  });

  const handleSubmit = async (values) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found");
      }

      const response = await axiosNewInstance.put(
        "/api-app/update-user-profile",
        {
          email: values.email,
          phone: values.phone,
          newPassword: values.newPassword || null,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === 1) {
        toast.success("Profile updated successfully!");
      } else {
        toast.error("Failed to update profile. Please try again.");
      }
    } catch (error) {
      toast.error("Error updating profile. Please try again.");
    }
  };

  return (
    <div className="container my-4">
      <Toaster />
      <div className="card shadow-md p-4">
        <div className="row">
          <div className="col-md-6" style={{ marginBottom: "35px" }}>
            <label className="form-label fw-bold"><LangData keyname="label_customer_id" /></label>
            <input
              type="text"
              value={user?.loginuser?.id}
              className="form-control bg-light"
              disabled
            />
          </div>
          <div className="col-md-6" style={{ marginBottom: "35px" }}>
            <label className="form-label fw-bold"><LangData keyname="label_name" /></label>
            <div className="form-control bg-light">
              {`${user?.loginuser?.first_name || ""} ${user?.loginuser?.last_name || ""}`}
            </div>
          </div>

          <div className="col-md-6" style={{ marginBottom: "35px" }}>
            <label className="form-label fw-bold"><LangData keyname="label_nominee_father_name" /></label>
            <input
              type="text"
              value={user?.loginuser?.father_name}
              className="form-control bg-light"
              disabled
            />
          </div>
          <div className="col-md-6" style={{ marginBottom: "35px" }}>
            <label className="form-label fw-bold"><LangData keyname="label_nominee_mother_name" /></label>
            <input
              type="text"
              value={user?.loginuser?.mother_name}
              className="form-control bg-light"
              disabled
            />
          </div>
          <div className="col-md-6" style={{ marginBottom: "35px" }}>
            <label className="form-label fw-bold"><LangData keyname="label_mobile" /></label>
            <input
              type="text"
              value={user?.loginuser?.mobile}
              className="form-control bg-light"
              disabled
            />
          </div>
          <div className="col-md-6" style={{ marginBottom: "35px" }}>
            <label className="form-label fw-bold"><LangData keyname="label_policy_holder_email" /></label>
            <input
              type="text"
              value={user?.loginuser?.email}
              className="form-control bg-light"
              disabled
            />
          </div>
          <div className="col-md-6" style={{ marginBottom: "35px" }}>
            <label className="form-label fw-bold"><LangData keyname="label_policy_holder_national_id" /></label>
            <input
              type="text"
              value={user?.loginuser?.national_id}
              className="form-control bg-light"
              disabled
            />
          </div>
          <div className="col-md-6" style={{ marginBottom: "35px" }}>
            <label className="form-label fw-bold"><LangData keyname="label_policy_holder_dob" /></label>
            <input
              type="text"
              value={user?.loginuser?.date_of_birth}
              className="form-control bg-light"
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  lang: state.lang,
});

export default connect(mapStateToProps)(Profile);
